import { RefreshCw } from "lucide-react"
import { LoadingOrb } from "./LoadingOrb"

export function PullLatestButton({
  busy = false,
  className = "",
  disabled = false,
  label = "Sync code",
  busyLabel = "Syncing code",
  onClick,
  title = "Sync latest code from the repository"
}) {
  const classes = [
    "repository-update-button",
    className,
    busy ? "is-busy" : ""
  ].filter(Boolean).join(" ")

  return (
    <button
      type="button"
      className={classes}
      disabled={disabled}
      onClick={onClick}
      title={title}
    >
      <span className="repository-update-icon" aria-hidden="true">
        {busy ? <LoadingOrb state="working" /> : <RefreshCw />}
      </span>
      <span className="repository-update-label">{busy ? busyLabel : label}</span>
    </button>
  )
}
